module.exports = __webpack_public_path__ + "static/media/large-banner.136ead5a.png";